<div class="content">
  <app-toggle
    *ngIf="!hideToggleButton"
    class="toggle-btn"
    [fieldId]="fieldId"
    [fieldControl]="fieldControl"
    [toggleInputE2eId]="toggleInputE2eId"
    [toggleLabelE2eId]="toggleLabelE2eId"
    [trackingIdentifier]="trackingIdentifier"
    [trackingAdditionalProperties]="trackingAdditionalProperties"
    [trackingScreenName]="trackingScreenName"
    [trackingObject]="trackingObject"
    (toggleClick)="fieldControl?.enabled && onClick.emit($event)"
  >
  </app-toggle>

  <div *ngIf="hideToggleButton" class="icon-wrapper">
    <app-icon class="lock-icon" [icon]="lockIcon"> </app-icon>
  </div>

  <app-icon
    *ngIf="icon"
    class="icon"
    [icon]="icon"
    (click)="onClickIcon.emit()"
  >
  </app-icon>

  <label
    class="toggle-label field-label"
    [ngClass]="{
      'sr-text': hideLabel,
      disabled: fieldControl?.disabled
    }"
    [attr.for]="fieldId"
    [attr.data-e2e-id]="labelE2eId"
    trackable
    [trackingObject]="trackingObject"
    (click)="fieldControl?.enabled && onClick.emit($event)"
  >
    {{ label }}
  </label>
</div>

<p *ngIf="description" class="description">
  {{ description }}
</p>
